import { defineStore, type _GettersTree } from 'pinia'
import getters from './getters.ts'
import actions from './actions.ts'
import initialState from './initialState.ts'
import type { ISearchState, ISearchGetters } from '../types.ts'

export const useSearchStore = defineStore<'searchStore', ISearchState, ISearchGetters>('searchStore', {
  state: (): ISearchState => ({ ...initialState }),
  getters,
  actions
})

export type ISearchStore = ReturnType<typeof useSearchStore>
